// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-windowpreviewimage_default__14wsy"};